import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'

import { NotificationController } from 'core-components/library/popup'
import {
  removeChangeRequest as removeChangeRequestApi,
  updateChangeRequest as updateChangeRequestApi,
} from 'partner360/features/hpContacts/api'

import { requestCreateChangeRequest } from '../thunks/requestCreateChangeRequest'
import { requestWelcomeFlowData } from '../thunks/requestWelcomeFlowData'

export const useWelcomeFlowApi = () => {
  const dispatch = useAppDispatch()

  const fetchData = useCallback(async () => {
    await dispatch(requestWelcomeFlowData()).unwrap()
  }, [dispatch])

  const createChangeRequest = useCallback(
    async (request: IFormJBPHPContactChangeRequest) => {
      await dispatch(requestCreateChangeRequest(request)).unwrap()
      await dispatch(requestWelcomeFlowData()).unwrap()
    },
    [dispatch]
  )

  const removeChangeRequest = useCallback(
    async (ticketId: number) => {
      try {
        await removeChangeRequestApi(ticketId)
        await fetchData()
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Failed to remove change request'
        NotificationController.showError({ message })
        throw error
      }
    },
    [fetchData]
  )

  const updateChangeRequest = useCallback(
    async (request: IFormJBPHPContactChangeRequest) => {
      try {
        await updateChangeRequestApi({ changeRequest: request })
        await fetchData()
      } catch (error) {
        const message = error instanceof Error ? error.message : 'Failed to update change request'
        NotificationController.showError({ message })
        throw error
      }
    },
    [fetchData]
  )

  return {
    fetchData,

    createChangeRequest,
    removeChangeRequest,
    updateChangeRequest,
  }
}
